<template>
    <div class="doc-section">
        <h1>Alarma Audible</h1>
        <p>
            El sistema permite gestionar avisos sonoros que se activan automáticamente al recibir una nueva
            notificación, facilitando el monitoreo cuando no se está visualizando la pantalla directamente.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />


        <div class="card">
            <p>
                <strong>Nota:</strong> Las notificaciones sonoras se encuentran <strong>activas por defecto</strong> al
                momento de registrar un nuevo usuario en la plataforma.
            </p>
        </div>

        <h2>Proceso de Configuración (Activar/Desactivar)</h2>
        <p>Para cambiar el estado de las alertas audibles, realice los siguientes pasos:</p>

        <ol class="ul-contenedor">
            <li>Diríjase al panel superior derecho donde se indica su <strong>Nombre de usuario</strong>.</li>
            <li>Haga clic sobre el nombre para desplegar el menú de opciones de cuenta.</li>
            <li>Localice la opción <strong>Notificaciones sonoras</strong>:
                <ul style="list-style: none; padding-left: 15px; margin-top: 5px;">
                    <li>a) Si el icono/texto no indica activación, haga clic para <strong>Activar</strong>.</li>
                    <li>b) Si las notificaciones ya se encuentran activas (como se muestra en el estado actual), haga
                        clic para <strong>Desactivar</strong>.</li>
                </ul>
            </li>
        </ol>

        <div class="card">
            <p>
                <strong>Verificación:</strong> Puede verificar el estado realizando el mismo proceso; el menú reflejará
                si la función está operando actualmente.
            </p>
        </div>


        <h3>Gestión de Alertas Sonoras</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesAudibles" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesAudiblesMoviles" />
        </div>
    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'AlertaAudible',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesAudibles: [
            {
                nombre: "Configuración Sonora",
                url: "img/Alertas/audible.png",
                descripcion: "Ubicación de la opción de notificaciones sonoras en el menú de perfil."
            },
            {
                nombre: "Mensaje de exito al configurar la notificación sonora",
                url: "img/Alertas/exitoNotificacionSonora.png",
                descripcion: ""
            }
        ],
        imagenesAudiblesMoviles: [
            {
                nombre: "Configuración Sonora",
                url: "img/Alertas/moviles/audible.png",
                descripcion: "Ubicación de la opción de notificaciones sonoras en el menú de perfil."
            },
            {
                nombre: "Mensaje de exito al configurar la notificación sonora",
                url: "img/Alertas/moviles/exitoNotificacionSonora.png",
                descripcion: ""
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>